import React, { useContext } from 'react';
import { EntitiesContext } from '../../../App';

export default function ListVendors() {
  const entities = useContext(EntitiesContext);
  const vendors = entities.state.get('account').filter(a => a.role === 'vendor');

  return (
    <div className="container">
      <table className="table is-fullwidth">
        <thead>
          <tr>
            <td>Vendor</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          {vendors.valueSeq().map(v => <tr key={v.id}>
            <td>{v.vendor_name}</td>
            <td>{/*edit | details*/}</td>
          </tr>)}
        </tbody>
      </table>
    </div>
  )
}
